import type { PartnerOrganization } from "@entities";
import CloseIcon from "@mui/icons-material/Close";
import {
  Avatar,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { sameOriginImageURL } from "@shared/helpers/constants";

type Props = {
  open: boolean;
  organization: PartnerOrganization | null;
  onClose: () => void;
};

const yesNo = (value: boolean) => (value ? "כן" : "לא");

export function PartnerOrganizationDetailsDialog({
  open,
  organization,
  onClose,
}: Props) {
  if (!organization) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth dir="rtl">
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
        }}
      >
        <Stack direction="row" alignItems="center" gap={1.5} sx={{ minWidth: 0 }}>
          <Avatar
            src={
              organization.logoImageId
                ? sameOriginImageURL(organization.logoImageId)
                : undefined
            }
            alt={organization.name}
            imgProps={{ referrerPolicy: "no-referrer" }}
            sx={{ width: 48, height: 48 }}
          />
          <Typography variant="h6" component="span" noWrap>
            {organization.name}
          </Typography>
        </Stack>
        <IconButton onClick={onClose} aria-label="סגירה" size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Stack gap={2}>
          <Stack gap={0.5}>
            <Typography variant="subtitle2" color="text.secondary">
              תיאור
            </Typography>
            <Typography variant="body1">
              {organization.description?.trim() || "—"}
            </Typography>
          </Stack>
          <Divider />
          <Stack direction="row" gap={3} flexWrap="wrap">
            <Stack gap={0.5}>
              <Typography variant="subtitle2" color="text.secondary">
                קולט קבוצות
              </Typography>
              <Typography variant="body1">
                {yesNo(organization.acceptsGroups)}
              </Typography>
            </Stack>
            <Stack gap={0.5}>
              <Typography variant="subtitle2" color="text.secondary">
                דוברי אנגלית
              </Typography>
              <Typography variant="body1">
                {yesNo(organization.acceptsEnglishSpeakers)}
              </Typography>
            </Stack>
          </Stack>
          <Stack gap={0.5}>
            <Typography variant="subtitle2" color="text.secondary">
              נוצר
            </Typography>
            <Typography variant="body2">
              {organization.createdAt?.toLocaleDateString("he-IL") ?? "—"}
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
